// extracted by mini-css-extract-plugin
export default {"container":"NewDoctorDashboard_container__jceaF","card":"NewDoctorDashboard_card__n6lIY","timer":"NewDoctorDashboard_timer__H1VLF","aiCard":"NewDoctorDashboard_aiCard__kpf-I"};